import React from "react";
import { Col, Form } from "antd";
import CustomTitle from "../../../components/CustomTitle.jsx";
import CustomParagraph from "../../../components/CustomParagraph.jsx";
import CustomSelect from "../../../components/CustomSelect.jsx";
import CheckboxSelector from "../../../components/CheckBoxSelector.jsx";
import AddSelectableItem from "../../../components/AddSelectableItem.jsx";
import ShipmentAlertThresholds from "./ShipmentAlertThresholds.jsx";
import { DownOutlined } from "@ant-design/icons";

const NotificationTypeFields = ({
  selectedType,
  step,
  shipment,
  setStep,
  selectedThresholds,
  setSelectedThresholds,
  selectedUserGroup,
  setSelectedUserGroup,
  locationList,
      thresholds,
            setThresholds,
}) => {
  const changedByList = [
    { value: "15 minutes", label: "15 minutes" },
    { value: "30 minutes", label: "30 minutes" },
    { value: "1 hour", label: "1 hour" },
    { value: "Over 2 hours", label: "Over 2 hours" },
  ];

  const handleUserGroupChange = (newValues) => {
    setSelectedUserGroup(newValues);
  };

  switch (selectedType?.id) {
    case "CRITICAL_ALERT":
      return (
        <Form.Item>
          {step === 2 && (
            <>
              <CustomTitle
                text="Add a Critical / At-risk alert"
                fontSize="20px"
                fontWeight="700"
                lineHeight="28px"
                color="black"
                marginBottom="10px"
              />
              <div>
                <CustomTitle
                  text="Alert type"
                  fontSize="14px"
                  fontWeight="600"
                  lineHeight="24px"
                  marginTop={15}
                  color="#000"
                  marginBottom="0"
                />
                <CustomParagraph
                  text="Setup custom alerts and modify their default thresholds"
                  fontSize="12px"
                  color="#5E5E5E"
                  marginBottom="10px"
                />
              </div>
            </>
          )}

          <ShipmentAlertThresholds
          shipment={shipment}
            thresholds={thresholds}
            setThresholds={setThresholds}
            step={step}
            setStep={setStep}
            selectedThresholds={selectedThresholds}
            setSelectedThresholds={setSelectedThresholds}
          />

          {step === 2 && (
            <AddSelectableItem text="Select alert" onClick={() => setStep(3)} />
          )}
        </Form.Item>
      );

    case "PICKUP_DELIVERY":
      return (
        <Form.Item>
          <CustomTitle
            text="Pickup / Delivery confirmation"
            fontSize="20px"
            fontWeight="700"
            lineHeight="28px"
            color="black"
            marginBottom="10px"
          />
          <CustomTitle
            text="Type"
            fontSize="14px"
            fontWeight="600"
            lineHeight="16px"
            color="black"
            marginBottom="10px"
          />
          <CheckboxSelector
            selectedValues={selectedUserGroup}
            onChange={handleUserGroupChange}
            noDesc={true}
            layout="horizontal"
            options={[
              {
                value: "pickup",
                label: "Pickup",
                description: "Notification when there has been a successful pickup",
              },
              {
                value: "delivery",
                label: "Delivery",
                description: "Notification when there has been a successful delivery",
              },
            ]}
          />
        </Form.Item>
      );

    case "AT_LOCATION":
      return (
        <Col span={24}>
          <CustomTitle
            text="Location"
            fontSize="20px"
            fontWeight="700"
            lineHeight="28px"
            color="black"
            marginBottom="10px"
          />
          <CustomTitle
            text="Location"
            fontSize="14px"
            fontWeight="600"
            lineHeight="16px"
            color="black"
            marginBottom="5px"
          />
          <Form.Item
            className="custom-input form-input-style"
            name="facility_type"
            rules={[{ message: "Select a type" }]}
          >
            <CustomSelect
              width="100%"
              placeholder="Select..."
              suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
              options={
                Array.isArray(locationList)
                  ? locationList.map((loc) => ({
                      value: loc?.id,
                      label: loc?.name,
                    }))
                  : []
              }
              bgColor="#F3F3F3"
              textColor="#5E5E5E"
              borderRadius="8px"
              height="36px"
              border="none"
              placeholderColor="#5E5E5E"
            />
          </Form.Item>
        </Col>
      );

    case "ETA_BASED":
      return (
        <Col span={24}>
          <CustomTitle
            text="ETA"
            fontSize="20px"
            fontWeight="700"
            lineHeight="28px"
            color="black"
            marginBottom="10px"
          />
          <CustomTitle
            text="Changed by"
            fontSize="14px"
            fontWeight="600"
            lineHeight="16px"
            color="black"
            marginBottom="5px"
          />
          <Form.Item
            name="changed_by"
            rules={[{ message: "Select a type" }]}
            style={{ marginBottom: "10px" }}
          >
            <CustomSelect
              width="100%"
              suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
              placeholder="Select..."
              options={changedByList}
              bgColor="#F3F3F3"
              textColor="#5E5E5E"
              borderRadius="8px"
              height="36px"
              border="none"
              placeholderColor="#5E5E5E"
            />
          </Form.Item>
        </Col>
      );

    default:
      return null;
  }
};

export default NotificationTypeFields;
